import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { addNewItem, resetAllItems } from '../features/productsSlice';

export default function ProductsInput() {
    const nameRef = useRef()
    const amountRef = useRef();
    const dispatch = useDispatch();


    const onAddClick = () => {
        let productObj = {
            name: nameRef.current.value,
            amount: amountRef.current.value,
            id: Date.now()
        }
        console.log(productObj);
        dispatch(addNewItem({ productItem: productObj }))
    }


    return (
        <div className='col-md-10 col-lg-8 text-center mx-auto'>
            <div className='text-start'> <label>Enter product name:</label></div>
            <input ref={nameRef} type="text" className="form-control mb-2 shadow"/>
            <div className='text-start'><label>Enter amount:</label></div>
            <input ref={amountRef} type="number" className="form-control mb-2 shadow" />
            <div className='text-center my-4'>
                <button onClick={onAddClick} className='btn btn-success me-2'>add new</button>
                <button onClick={() => {
                    window.confirm("Are you sure you want reset the list?")&&
                    dispatch(resetAllItems())
                }} className='btn btn-danger '>reset all</button>
            </div>
        </div>
    )
}
